export default "__VITE_ASSET__5ac2c4a1__"